/**
 * デバッグ関連ユーティリティ
 */
import { appConfig } from '../config/env';

/**
 * デバッグUIの表示可否を判定
 *
 * @returns デバッグUIを表示する場合 true
 */
export function isDebugFieldStateUIEnabled(): boolean {
  return appConfig.debug.fieldStateUi;
}
